import React, { useState, useEffect, useRef } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useHotkeys } from 'react-hotkeys-hook'
import { useTracking } from 'react-tracking'

import PieTimerAnimation from 'components/common/animations/PieTimer'
import useLocalVideoToggle from 'hooks/useLocalVideoToggle/useLocalVideoToggle'
import { isDesktop } from 'utils/device'
import { logger } from 'utils/logger'

import { MenuIcon } from '../styles'
import { BtnWrapper, AnimWrapper, Button } from '../ToggleAudioButton/styles'
import StyledTooltip from '../TooltipWrapper'

const ToggleVideoButton = props => {
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle()
    const btnRef = useRef(null)
    const isMountedRef = useRef(false)

    const tracking = useTracking()

    const [blockVideoTimerAnim, setBlockVideoTimerAnim] = useState(false)

    useEffect(() => {
        isMountedRef.current = true
        return () => {
            isMountedRef.current = false
        }
    }, [])
    useEffect(() => {
        blockVideoTimerAnim &&
            setTimeout(() => {
                if (isMountedRef.current) {
                    setBlockVideoTimerAnim(false)
                }
            }, 2000)
    }, [blockVideoTimerAnim])

    useEffect(() => {
        tracking &&
            tracking.trackEvent({
                action: isVideoEnabled ? 'video_on' : 'video_off',
            })
        logger.debug(`User video status : ${isVideoEnabled ? 'on' : 'off'}`)
    }, [isVideoEnabled, tracking])

    useHotkeys('ctrl+.', event => {
        event.preventDefault()
        btnRef.current && btnRef.current.click()
    })

    const menuSrc = isVideoEnabled
        ? `/assets/controls/latest/videoOn.svg`
        : `/assets/controls/latest/videoOff.svg`

    console.count('ToggleVideoButton Component')

    const btnProps = {
        onClick: () => {
            if (blockVideoTimerAnim) return
            toggleVideoEnabled()
            setBlockVideoTimerAnim(true)
        },
        disabled: props.disabled,
        'data-cy-audio-toggle': true,
        clicked: !isVideoEnabled,
        isMobile: isMobileOnly,
    }

    return (
        <StyledTooltip
            title={
                isDesktop
                    ? isVideoEnabled
                        ? 'disable video'
                        : 'enable video'
                    : ''
            }
            placement="left"
            arrow
            PopperProps={{ disablePortal: true }}
        >
            <BtnWrapper disabled={blockVideoTimerAnim}>
                {blockVideoTimerAnim && (
                    <AnimWrapper>
                        <PieTimerAnimation />
                    </AnimWrapper>
                )}
                <Button {...btnProps} ref={btnRef}>
                    <MenuIcon
                        clicked={!isVideoEnabled}
                        src={menuSrc}
                        alt="menu"
                    />
                </Button>
            </BtnWrapper>
        </StyledTooltip>
    )
}
export default ToggleVideoButton
